import { api } from 'API/axios';
import { IActionType } from 'Modules/Home/CommonActions';
import { addImposterToUrl } from 'Utils';
const MAX_ITEMS = 6;
const baseUrl = `/LobbyActivity?activitiesCount=${MAX_ITEMS}`;
export const getActivities = async () => {
  const res = await api.get<IActionType[]>(addImposterToUrl(baseUrl));
  if (res.data) return res.data;
};
